import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Link } from "gatsby"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-c191254f72/icons'

// Import Images
import logolight from "../../assets/images/gallium/galliumwhiteontransparent.png";

const Footer = () => {
    return (
        <React.Fragment>
            <footer className="custom-footer bg-dark py-5 position-relative">
                <Container>
                    <Row>
                        <Col lg={4} className="mt-4">
                            <div>
                                <div>
                                    <img src={logolight} alt="logo light" height="30" />
                                </div>
                                <div className="mt-4">
                                    <p>Enabling the next generation of edge computing - one server at a time.</p>
                                </div>
                                <div className="mt-4">
                                    <p><strong>North America - </strong>447 Broadway, 2nd Floor #2339, New York, NY 10013, USA</p>
                                    <p><strong>Asia Pacific - </strong>Level 4, 40 McDougall St, Milton QLD 4064, Australia</p>
                                </div>
                                
                            </div>
                        </Col>

                        <Col lg={7} className="ms-lg-auto">
                            <Row>
                                <Col sm={4} className="mt-4">
                                    <h5 className="text-white mb-0">Product</h5>
                                    <div className="text-muted mt-3">
                                        <ul className="list-unstyled ff-secondary footer-list">
                                            <li><Link to="/Tour">Product Tour</Link></li>
                                            <li><Link to="/Pricing">Pricing</Link></li>
                                        </ul>
                                    </div>
                                </Col>
                                <Col sm={4} className="mt-4">
                                    <h5 className="text-white mb-0">Trust</h5>
                                    <div className="text-muted mt-3">
                                        <ul className="list-unstyled ff-secondary footer-list">
                                            <li><Link to="/Trust/Privacy">Privacy Policy</Link></li>
                                        </ul>
                                    </div>
                                </Col>
                                <Col sm={4} className="mt-4">
                                    <h5 className="text-white mb-0">Support</h5>
                                    <div className="text-muted mt-3">
                                        <ul className="list-unstyled ff-secondary footer-list">
                                            <li><a href="https://docs.gallium.cloud">Documentation</a></li>
                                        </ul>
                                    </div>
                                </Col>
                            </Row>
                        </Col>

                    </Row>

                    <Row className="text-center text-sm-start align-items-center mt-5">
                        <Col sm={6}>

                            <div>
                                <p className="copy-rights mb-0">
                                    {new Date().getFullYear()} © Gallium Cloud Inc.
                                </p>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <div className="text-sm-end mt-3 mt-sm-0">
                                <ul className="list-inline mb-0 footer-social-link">
                                    <li className="list-inline-item">
                                        <a href="https://www.linkedin.com/company/galliumcloud" className="avatar-xs d-block" aria-label="Visit our LinkedIn Page">
                                            <div className="avatar-title rounded-circle">
                                                <FontAwesomeIcon icon={byPrefixAndName.fab["linkedin"]} />
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment >
    );
};



export default Footer;